import React from 'react';
import Utils from '../providers/Utils';
import { Avatar, Grid } from '@material-ui/core';
import FromServer from '../module/projects/FromServer';
import PropTypes from 'prop-types'


export default class GanttEtapeWeekView extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
            isEtapaClicked:false,
            objEtapa:{}
        }
    }

    etapa = {denumire:''}
    componentDidMount(){
      let el = document.getElementById('pm-gantt-etape-container')
      el.addEventListener('scroll', this.getEtapeTitle)
      
      
    this.goToElement()
  }

  componentWillUnmount(){
    let el = document.getElementById('pm-gantt-etape-container')
    el.removeEventListener('scroll', this.getEtapeTitle)
  }

  getSubtaskuriLength = (idTask) =>{

    let subtaskuriFilter = this.props.listSubtaskuri.filter(i => i.id_task_parent === idTask)

    // console.log('subtaskuriFilter :', subtaskuriFilter);

    let subtaskuriFinalizateFilter = subtaskuriFilter.filter(i => i.statusul === 'Finalizat')

    let objR = {
        sT:subtaskuriFilter.length,
        sTF:subtaskuriFinalizateFilter.length
    }

    return objR

}



  isInViewport =  (elem) =>{
    let bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
         bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};


   getEtapeTitle = () =>{


    let u = new Utils();
      let etape = this.props.etape

      let etapa =''

      let etapaLast = ''
      let etapaSelectata = null

      let counter = etape.length

      for(let i=0; i < counter; i++){
        etapa = document.getElementById(`#${u.dataPrescurtataEngNoYear(etape[i].durata_de_la)}`)
        etapaLast = document.getElementById(`#${u.dataPrescurtataEngNoYear(etape[i].durata_pana_la)}`)
        if(this.isInViewport(etapa)){
             etapaSelectata = etape[i]

            // console.log('etape[i] :', etape[i]);
        }else{
          // console.log('etapa not in view');
        }
      
      }

      // console.log('etapaSelectata :', etapaSelectata);
if(etapaSelectata){

  if(etapaSelectata.id !== this.state.objEtapa.id){
    this.setState({objEtapa:etapaSelectata})
  }else{
    // console.log('acelasiTitlu :');
  }
}

      
   }  



  etapaClick = (e) =>{

    // console.log('etapa :', e);
    if(this.state.isEtapaClicked){
      this.setState({isEtapaClicked:false,
                    objEtapa:{}})
    }else{
      this.setState({isEtapaClicked:true,
                    objEtapa:e})
    }
  }



  // filterCuloareEtapa = (l) =>{

    
  //   let u = new Utils();


  //   let filteredList = l.filter(i => i.statusul !== 'Finalizat')

  //   let taskuriTrecute = filteredList.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)) < new Date() )

  //   if(taskuriTrecute.length > 0){
  //       return'#ff3f3f'
  //   }else if (filteredList.length > 0){
  //      return 'rgb(247, 167, 16)'
  //   }else{
  //      return '#7ad13a'
  //   }

  // }


  taskId = ''
  taskEl=''
  getLitereAvatar = (tx)=>{



    if(tx !== null){

        return tx.substring(0,2)
    }
}

afiseazaData = (dataStart, dataFinish, limba,f) =>{

  let u = new Utils()



  if(limba === 'en'){
 
      let _dataStart = dataStart !== null ? u.dataPrescurtataEng(dataStart) : this.props.dictionary.noData
      let _dataFinish = dataFinish !== null ?  u.dataPrescurtataEng(dataFinish)  : this.props.dictionary.noData

      let span =   <span   className='pm-gantt-task-date'>{_dataStart} - {_dataFinish} </span> 
      return span
      

  }else{
      let _dataStart = dataStart !== null ? u.dataPrescurtataRomana(dataStart) : this.props.dictionary.noData
      let _dataFinish = dataFinish !== null ?  u.dataPrescurtataRomana(dataFinish)  : this.props.dictionary.noData

      let span =   <span  style={{backgroundColor:f.color, width:200}} className='pm-gantt-task-date'>{_dataStart} - {_dataFinish} </span> 

      return span
  }
}

   goToElement =async () =>{


      await this.getDates()

       let u = new Utils()

       let date = u.dataPrescurtataEngNoYear(u.defaultData())

       if(new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela)) > new Date() ){

        date = u.dataPrescurtataEngNoYear(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela))
       }

       let etapa = this.props.etape

      //  console.log('etapa :', etapa);

       let idx = etapa.findIndex(e =>( new Date() > new Date(e.durata_de_la) && new Date() < new Date(e.durata_pana_la)  )  )

      //  console.log('idx :', idx);
      
          // console.log('date :', date);
         let data = document.getElementById(`#${date}`)
   
         data.scrollIntoView({behavior:'smooth', block:'center', inline:'center'})
        
    

        // console.log('date :', date);

    //  console.log('data :', data);
   }

   getWeekEndColor = (t,dt) => {

    // console.log('dataSTart :', dt);

    let u = new Utils()

    if(u.transformDataForSql(dt) === u.defaultData()){
        return 'repeating-linear-gradient(135deg, rgb(241, 241, 241), rgb(160, 143, 243) 0.25em, rgba(74, 36, 222, 0.53) 0px, rgba(16, 187, 187, 0.35) 0.3em)'
    }else{
        if (t === 0) {
            return 'rgb(228, 228, 228)'
        } else if (t === 6) {
            return 'rgb(228, 228, 228)'
        } else {
            return 'white'
        }
    }
    
}


   dragTask=(t, ev)=>{
      // console.log('t :', t);

     let taskDraged = ev.target


    taskDraged.style.opacity = 'none'

setTimeout(()=>{
  taskDraged.classList.add('pm-hide-dragged-element')
})

     

     this.taskEl = taskDraged

     this.taskId = t
   }

   endDragTask =(ev)=>{
     let taskDraged = ev.target;

     taskDraged.classList.remove('pm-hide-dragged-element')
   }

   taskOver = (ev) =>{
    ev.stopPropagation();
    ev.preventDefault();
}

  updateTask = (newDate, panaDate) =>{

        let fs = new FromServer();


        let obj = {
          cand_data: newDate,
          pana_cand_data:panaDate
        }


        let id = this.taskId.id

         let updateT = fs.updateTask(obj,id)

         if(updateT){
           this.props.getData()
         }
        // console.log('obj :', obj);
        // console.log('id :', id);




  }

dropTask = (ev) =>{
    // console.log('taskId :', ev.target.id);

    let u = new Utils();

   let data =  u.transformDataForSql(ev.target.id)

   let dataPanaLa = new Date(ev.target.id)

   

    //  console.log('data :', data);

  //  console.log('taskId :', this.taskId);

   let date2 = new Date(this.taskId.cand_data);
 let date1 = new Date(this.taskId.pana_cand_data);
 let timeDiff = Math.abs(date2.getTime() - date1.getTime());
 let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));
// console.log('object :', dayDifference); 

dataPanaLa = dataPanaLa.setDate(dataPanaLa.getDate() + dayDifference)

dataPanaLa = u.transformDataForSql(dataPanaLa)



// console.log('dataPanaLa :', dataPanaLa);
   this.updateTask(data, dataPanaLa)
}



// getDatesEtapa =() =>{
//  // console.log(' gantttt this.props.objInfoProiect :', this.props.objInfoProiect);

//  let u = new Utils()

//  let taskHeight = 40




//  let dataStartHead = this.props.objInfoProiect[0].perioada_dela !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela)) :new Date(u.defaultData())
       
//         let dataFinishHead = this.props.objInfoProiect[0].perioada_panala !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_panala)) :new Date(u.defaultDataPlus3Months())

//  let cloneTaskuri = [...this.props.listTaskuri]

//  // console.log('cloneTaskuri :', cloneTaskuri);

//  let filterByEtapa = cloneTaskuri.filter(f => f.cand_data !== null )

//   filterByEtapa = filterByEtapa.filter(f => f.id_task_parent === null)

//  // console.log('filter :', filterByEtapa);

 

//  let etapa = this.state.objEtapa 


//  let container = []

//  let etapaContainer = []


//  let head = []



// if(this.props.dictionary.date === 'en'){
//   for(dataStartHead; dataStartHead<= dataFinishHead; dataStartHead.setDate(dataStartHead.getDate()+1) ){
//    let todayH = dataStartHead.getDay()
//    head.push(<div style={{backgroundColor:this.getWeekEndColor(todayH)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStartHead)} id={`#${u.dataPrescurtataEngNoYear(dataStartHead)}`} >  {u.dataPrescurtataRomanaNoYear(dataStartHead)}</div>)


//   }
     
  

   
//        let body = []
       
//        let dataStart = this.props.objInfoProiect[0].perioada_dela !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela)) :new Date(u.defaultData())
       
//               let dataFinish = this.props.objInfoProiect[0].perioada_panala !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_panala)) :new Date(u.defaultDataPlus3Months())

//        let culoare=''

//        for(dataStart; dataStart<= dataFinish; dataStart.setDate(dataStart.getDate()+1) ){

//        let filterTaskuri = filterByEtapa.filter(tsk => tsk.id_etapa_proiect === etapa.id);

//       //  culoare = this.filterCuloareEtapa(filterTaskuri)

//        // console.log('filterTaskuri------------- :', filterTaskuri);
 
//        let counter = filterTaskuri.length;
 
    
 
//        let body = []

//          let task = []

     

      

//        for(let i = 0; i< counter; i ++){

         
//          if(u.transformDataForSql(dataStart) === u.ParseDataFromSql(filterTaskuri[i].cand_data)){


         
//            let newFilter = filterTaskuri.filter(k => k.id !== filterTaskuri[i].id )

//            let idx = newFilter.findIndex(j =>new Date(j.pana_cand_data) >= new Date(filterTaskuri[i].cand_data) )

//            // console.log('idx :', idx);

//            if(idx !== -1){

//              task.push(
//                        <div  draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i],ev)}} key={i} id={'pm-gantt-item-id'+i}   className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5) * (i + 1),  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101), position:'relative'}}>
//                            <div onClick={()=>{this.props.OpenTask(filterTaskuri[i])}}  className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'>
//                          { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) } </div>
//                          <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i>
//                          </div>
//                          )
            
             
//            }else{ 
//              task.push(
//                <div draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i], ev)}} key={i} id={'pm-gantt-item-id'+i}   className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5),  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101),position:'relative'}}>
//                  <div   onClick={()=>{this.props.OpenTask(filterTaskuri[i])}} className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'> 
//              { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) }</div>
//                 <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i> 
//              </div>
//              )
                                
//           }
           
          

//            }


//        }

//         let today = dataStart.getDay()
//        // head.push(<div style={{backgroundColor:this.getWeekEndColor(today)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} id={`#${u.dataPrescurtataEngNoYear(dataStart)}`} >  {u.dataPrescurtataRomanaNoYear(dataStart)}</div>)

//        body.push(<div id={`${dataStart}`} onDragOver={(ev)=>{this.taskOver(ev)}} onDrop={(ev)=>{this.dropTask(ev)}} style={{background: this.getWeekEndColor(today,dataStart)}} className='pm-gantt-body-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} >{task}</div>)
     
//      //   calendar.push(u.dataPrescurtataEngNoYear (dataStart))
//    }
//    etapaContainer=<div  style={{height:'100%', borderBottom:'1px dashed gray'}}>

//    <div className='pm-etapa-title'>

//    <div style={{position:'relative'}} onClick={()=>{this.etapaClick(etapa)}}  className='pm-list-container-etapa-gantt'>
//              <div style={{backgroundColor:etapa.color}} className='pm-list-borderleft'></div> 
             

//               <div  className='pm-list-container-task-content'>
                           
//               <span  style={{marginTop:0, paddingTop:12}}   className='pm-list-item-task'>{etapa.denumire}</span> 
             
              
           
//          </div>
//      </div>
   
//    </div>
     
         

//                <div  className='pm-gantt-body'>
//                {body}
//                </div>
       

//      </div>





 

// }else{


//  for(dataStartHead; dataStartHead<= dataFinishHead; dataStartHead.setDate(dataStartHead.getDate()+1) ){
//    let todayH = dataStartHead.getDay()
//    head.push(<div style={{backgroundColor:this.getWeekEndColor(todayH)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStartHead)} id={`#${u.dataPrescurtataEngNoYear(dataStartHead)}`} >  {u.dataPrescurtataRomanaNoYear(dataStartHead)}</div>)


//   }


   
//      let body = []

//      let culoare=''

//      let dataStart = this.props.objInfoProiect[0].perioada_dela !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela)) :new Date(u.defaultData())
       
//               let dataFinish = this.props.objInfoProiect[0].perioada_panala !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_panala)) :new Date(u.defaultDataPlus3Months())

//      for(dataStart; dataStart<= dataFinish; dataStart.setDate(dataStart.getDate()+1) ){

//      let filterTaskuri = filterByEtapa.filter(tsk => tsk.id_etapa_proiect === etapa.id);

//      // console.log('filterTaskuri------------- :', filterTaskuri);

//     //  culoare = this.filterCuloareEtapa(filterTaskuri)

//      let counter = filterTaskuri.length;

    

    

    

//    let task = []

//    for(let i = 0; i< counter; i ++){

         
//      if(u.transformDataForSql(dataStart) === u.ParseDataFromSql(filterTaskuri[i].cand_data)){


     
//        let newFilter = filterTaskuri.filter(k => k.id !== filterTaskuri[i].id )

//        let idx = newFilter.findIndex(j =>new Date(j.pana_cand_data) >= new Date(filterTaskuri[i].cand_data) )

//        // console.log('idx :', idx);

//        if(idx !== -1){

//          task.push(
//                    <div draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i],ev)}} key={i} id={'pm-gantt-item-id'+i} className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5) * (i + 1),  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101), position:'relative'}}>
//                        <div  onClick={()=>{this.props.OpenTask(filterTaskuri[i])}}  className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'>
//                      { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) } </div>
//                      <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i>
//                      </div>
//                      )
        
         
//        }else{ 
//          task.push(
//            <div draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i], ev)}} key={i} id={'pm-gantt-item-id'+i} className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5),  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101),position:'relative'}}>
//              <div   onClick={()=>{this.props.OpenTask(filterTaskuri[i])}}  className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'> 
//          { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) }</div>
//             <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i> 
//          </div>
//          )
                            
//       }
       
      

//        }


//    }

//     let today = dataStart.getDay()
//    //   head.push(<div style={{backgroundColor:this.getWeekEndColor(today)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} id={`#${u.dataPrescurtataEngNoYear(dataStart)}`} >  {u.dataPrescurtataRomanaNoYear(dataStart)}</div>)

//      body.push(<div id={`${dataStart}`} onDragOver={(ev)=>{this.taskOver(ev)}} onDrop={(ev)=>{this.dropTask(ev)}} style={{background: this.getWeekEndColor(today,dataStart)}} className='pm-gantt-body-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} >{task}</div>)
   
//    //  calendar.push(u.dataPrescurtataRomanaNoYear(dataStart))
 
//  etapaContainer=
 
//   <div  style={{height:'100%', borderBottom:'1px dashed gray'}}>

//    <div className='pm-etapa-title'>

//    <div style={{position:'relative'}} onClick={()=>{this.etapaClick(etapa)}}  className='pm-list-container-etapa-gantt'>
//              <div style={{backgroundColor:etapa.color}} className='pm-list-borderleft'></div> 
             

//               <div  className='pm-list-container-task-content'>
                           
//               <span  style={{marginTop:0, paddingTop:12}}   className='pm-list-item-task'>{etapa.denumire}</span> 
             
              
           
//          </div>
//      </div>
   
//    </div>
     
         

//                <div  className='pm-gantt-body'>
//                {body}
//                </div>
       

//      </div>



// }

// }

// container  = 
//       <div  style={{height:'100%'}}>
//       <div className='pm-gantt-head'>
//       {head} 
//       </div> 
      

//       {etapaContainer}

//       </div>






//  return container


// }


   

    getDates = () =>{
        // console.log(' gantttt this.props.objInfoProiect :', this.props.objInfoProiect);

        let u = new Utils()

        let taskHeight = 40

       

        // console.log('data start :', u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela));


        // console.log('data Finish :', u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_panala));
     
      
        let dataStartHead = this.props.objInfoProiect[0].perioada_dela !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela)) :new Date(u.defaultData())
       
        let dataFinishHead = this.props.objInfoProiect[0].perioada_panala !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_panala)) :new Date(u.defaultDataPlus3Months())

        let cloneTaskuri = [...this.props.listTaskuri]

        // console.log('dataStartHead :', dataStartHead);

        // console.log('dataFinishHead :', dataFinishHead);

        // console.log('cloneTaskuri :', cloneTaskuri);

        let filterTaskuri = cloneTaskuri.filter(f => f.cand_data !== null )

        filterTaskuri = filterTaskuri.filter(f => f.id_task_parent === null)

        // console.log('filter :', filterByEtapa);

        let etapa = this.state.objEtapa

        let counter2 = this.props.etape.length


        let container = []

        let etapaContainer = []


        let head = []

     

      if(this.props.dictionary.date === 'en'){
         for(dataStartHead; dataStartHead<= dataFinishHead; dataStartHead.setDate(dataStartHead.getDate()+1) ){
          let todayH = dataStartHead.getDay()
          head.push(<div style={{backgroundColor:this.getWeekEndColor(todayH)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStartHead)} id={`#${u.dataPrescurtataEngNoYear(dataStartHead)}`} >  {u.dataPrescurtataEngNoYear(dataStartHead)}</div>)


         }
            
         

         let body = []
            
              
              let dataStart = this.props.objInfoProiect[0].perioada_dela !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela)) :new Date(u.defaultData())
       
              let dataFinish = this.props.objInfoProiect[0].perioada_panala !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_panala)) :new Date(u.defaultDataPlus3Months())

              let culoare=''

              for(dataStart; dataStart<= dataFinish; dataStart.setDate(dataStart.getDate()+1) ){

              // let filterTaskuri = filterByEtapa.filter(tsk => tsk.id_etapa_proiect === this.props.etape[e].id);

              // culoare = this.filterCuloareEtapa(filterTaskuri)
  
              // console.log('filterTaskuri------------- :', filterTaskuri);
        
              let counter = filterTaskuri.length;
        
           
        
       
  
                let task = []

            

             

              for(let i = 0; i< counter; i ++){

                
                if(u.transformDataForSql(dataStart) === u.ParseDataFromSql(filterTaskuri[i].cand_data)){
    
    
                
                  let newFilter = filterTaskuri.filter(k => k.id !== filterTaskuri[i].id )
    
                  let idx = newFilter.findIndex(j =>new Date(j.pana_cand_data) > new Date(filterTaskuri[i].cand_data) )
    
                  // console.log('idx :', idx);
    
                  if(idx !== -1){
    
                    task.push(
                              <div  draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i],ev)}} key={i} id={'pm-gantt-item-id'+i}   className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5) * (i + 1),  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101), position:'relative'}}>
                                  <div onClick={()=>{this.props.OpenTask(filterTaskuri[i])}}  className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'>
                                { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) }  {this.getSubtaskuriLength(filterTaskuri[i].id).sT > 0 && 
                              
                              <span className='pm-subtaskuri-gantt-length-container'>
                                  <i className='material-icons'>done</i>
                                  {this.getSubtaskuriLength(filterTaskuri[i].id).sTF + '/'+this.getSubtaskuriLength(filterTaskuri[i].id).sT}
                          </span>
                         } </div>
                               
                                <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i>
                                </div>
                                )
                   
                    
                  }else{ 
                    task.push(
                      <div draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i], ev)}} key={i} id={'pm-gantt-item-id'+i}   className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5),  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101),position:'relative'}}>
                        <div   onClick={()=>{this.props.OpenTask(filterTaskuri[i])}} className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'> 
                    { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) }  {this.getSubtaskuriLength(filterTaskuri[i].id).sT > 0 && 
                              
                              <span className='pm-subtaskuri-gantt-length-container'>
                                  <i className='material-icons'>done</i>
                                  {this.getSubtaskuriLength(filterTaskuri[i].id).sTF + '/'+this.getSubtaskuriLength(filterTaskuri[i].id).sT}
                          </span>
                         }</div>
                              
                       <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i> 
                    </div>
                    )
                                       
                 }
                  
                 
    
                  }
    
    
              }

               let today = dataStart.getDay()
              // head.push(<div style={{backgroundColor:this.getWeekEndColor(today)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} id={`#${u.dataPrescurtataEngNoYear(dataStart)}`} >  {u.dataPrescurtataRomanaNoYear(dataStart)}</div>)

              body.push(<div id={`${dataStart}`} onDragOver={(ev)=>{this.taskOver(ev)}} onDrop={(ev)=>{this.dropTask(ev)}} style={{backgroundColor: this.getWeekEndColor(today)}} className='pm-gantt-body-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} >{task}</div>)
            
            //   calendar.push(u.dataPrescurtataEngNoYear (dataStart))
          }
          // etapaContainer.push(<div key={`etapa${e}`} style={{height:'100%', borderBottom:'1px dashed gray'}}>
      
          // <div className='pm-etapa-title'>

          // <div style={{position:'relative'}} onClick={()=>{this.etapaClick(this.props.etape[e])}}  className='pm-list-container-etapa-gantt'>
          //           <div style={{backgroundColor:culoare}} className='pm-list-borderleft'></div> 
                    

          //            <div  className='pm-list-container-task-content'>
                                  
          //            <span  style={{marginTop:0, paddingTop:12}}   className='pm-list-item-task'>{this.props.etape[e].denumire}</span> 
                    
                     
                  
          //       </div>
          //   </div>
          
          // </div>
            
                

          //             <div  className='pm-gantt-body'>
          //             {body}
          //             </div>
              
  
          //   </div>)





        

      }else{


        for(dataStartHead; dataStartHead<= dataFinishHead; dataStartHead.setDate(dataStartHead.getDate()+1) ){
          let todayH = dataStartHead.getDay()
          head.push(<div style={{backgroundColor:this.getWeekEndColor(todayH)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStartHead)} id={`#${u.dataPrescurtataEngNoYear(dataStartHead)}`} >  {u.dataPrescurtataRomanaNoYear(dataStartHead)}</div>)


         }


     
         let body = []
         
            let culoare=''

            let dataStart = this.props.objInfoProiect[0].perioada_dela !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_dela)) :new Date(u.defaultData())
       
            let dataFinish = this.props.objInfoProiect[0].perioada_panala !== null ? new Date(u.ParseDataFromSql(this.props.objInfoProiect[0].perioada_panala)) :new Date(u.defaultDataPlus3Months())

            for(dataStart; dataStart<= dataFinish; dataStart.setDate(dataStart.getDate()+1) ){

            //  let filterTaskuri = filterByEtapa.filter(tsk => tsk.id_etapa_proiect === this.props.etape[e].id);

            // console.log('filterTaskuri------------- :', filterTaskuri);

            // culoare = this.filterCuloareEtapa(filterTaskuri)
      
            let counter = filterTaskuri.length;
      
           
      
           

           

          let task = []

          for(let i = 0; i< counter; i ++){

                
            if(u.transformDataForSql(dataStart) === u.ParseDataFromSql(filterTaskuri[i].cand_data)){


            
              let newFilter = filterTaskuri.filter(k => k.id !== filterTaskuri[i].id )

              let idx = newFilter.filter(j =>new Date(u.ParseDataFromSql(j.pana_cand_data)) > new Date(u.ParseDataFromSql(filterTaskuri[i].cand_data)) )

              // console.log('filter :', filterTaskuri[i]);
              // console.log('idx :', idx.length);
              // console.log('idx :', idx);

              if(idx.length > 0){

                task.push(
                          <div draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i],ev)}} key={i} id={'pm-gantt-item-id'+i} className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5) * (i + 1) ,  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101), position:'relative'}}>
                              <div  onClick={()=>{this.props.OpenTask(filterTaskuri[i])}}  className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'>
                            { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) }  {this.getSubtaskuriLength(filterTaskuri[i].id).sT > 0 && 
                              
                              <span className='pm-subtaskuri-gantt-length-container'>
                                  <i className='material-icons'>done</i>
                                  {this.getSubtaskuriLength(filterTaskuri[i].id).sTF + '/'+this.getSubtaskuriLength(filterTaskuri[i].id).sT}
                          </span>
                         } </div>
                           
                            <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i>
                            </div>
                            )
               
                
              }else{ 
                task.push(
                  <div draggable onDragEnd={(ev)=>{this.endDragTask(ev)}} onDragStart={(ev)=>{this.dragTask(filterTaskuri[i], ev)}} key={i} id={'pm-gantt-item-id'+i} className='pm-task-gantt-item-container' style={{height:taskHeight, marginTop: (taskHeight + 5),  width:(u.getDaysDifference(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data)* 101),position:'relative'}}>
                    <div   onClick={()=>{this.props.OpenTask(filterTaskuri[i])}}  className='pm-task-gantt-item' style={{height:taskHeight, backgroundColor:filterTaskuri[i].color}}><Avatar style={{display:'inline-flex'}}  className='pm-avatar'> 
                { this.getLitereAvatar(filterTaskuri[i].nume + ' ') } </Avatar><span className='pm-gant-task-title'>{filterTaskuri[i].titlu}</span> {this.afiseazaData(filterTaskuri[i].cand_data, filterTaskuri[i].pana_cand_data, this.props.dictionary.data,filterTaskuri[i]) }  {this.getSubtaskuriLength(filterTaskuri[i].id).sT > 0 && 
                              
                              <span className='pm-subtaskuri-gantt-length-container'>
                                  <i className='material-icons'>done</i>
                                  {this.getSubtaskuriLength(filterTaskuri[i].id).sTF + '/'+this.getSubtaskuriLength(filterTaskuri[i].id).sT}
                          </span>
                      } </div>
               
                   <i className='material-icons pm-resize-task-arrow'>arrow_right_alt</i> 
                </div>
                )
                                   
             }
              
             

              }


          }

           let today = dataStart.getDay()
          //   head.push(<div style={{backgroundColor:this.getWeekEndColor(today)}} className='pm-gantt-head-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} id={`#${u.dataPrescurtataEngNoYear(dataStart)}`} >  {u.dataPrescurtataRomanaNoYear(dataStart)}</div>)

            body.push(<div id={`${dataStart}`} onDragOver={(ev)=>{this.taskOver(ev)}} onDrop={(ev)=>{this.dropTask(ev)}} style={{backgroundColor: this.getWeekEndColor(today)}} className='pm-gantt-body-item' key={u.dataPrescurtataRomanaNoYear(dataStart)} >{task}</div>)
          
          //  calendar.push(u.dataPrescurtataRomanaNoYear(dataStart))
        
        // etapaContainer.push(<div key={`etapa${e}`} style={{height:'100%', borderBottom:'1px dashed gray'}}>
      
        //   <div className='pm-etapa-title'>

        //   <div style={{position:'relative'}} onClick={()=>{this.etapaClick(this.props.etape[e])}}  className='pm-list-container-etapa-gantt'>
        //             <div style={{backgroundColor:culoare}} className='pm-list-borderleft'></div> 
                    

        //              <div  className='pm-list-container-task-content'>
                                  
        //              <span  style={{marginTop:0, paddingTop:12}}   className='pm-list-item-task'>{this.props.etape[e].denumire}</span> 
                    
                     
                  
        //         </div>
        //     </div>
          
        //   </div>
            
                

        //               <div  className='pm-gantt-body'>
        //               {body}
        //               </div>
              
  
        //     </div>)




      }
    container  = 
    <div  style={{height:'100%'}}>
    <div className='pm-etapa-title'>

        <div style={{position:'relative'}} className='pm-list-container-etapa-gantt'>
                  <div style={{backgroundColor:etapa.color}} className='pm-list-borderleft'></div> 
                  

                  <div style={{cursor:'default'}} className='pm-list-container-task-content'>
                                
                  <span  style={{marginTop:0, paddingTop:12}}   className='pm-list-item-task'>{etapa.denumire}</span> 
                  
                  
                
              </div>
          </div>

        </div>
    <div className='pm-gantt-head'>
    {head} 
    </div> 

     <div  className='pm-gantt-body'>
    
                           
                       
                          
                           
                        
                    
                      {body}
                      </div>

    {/* {etapaContainer} */}

    </div>


    }
      
        return container


    }

    
     render() { 
       return (
          <div className='pm-gant-container'>
          
               
                   {this.getDates()}
                   {/* this.getDatesEtapa() */}
              
         </div>
        );
       }
}//end class


GanttEtapeWeekView.propType = {
  objInfoProiect:PropTypes.object,
  listTaskuri:PropTypes.array,
  listSubtaskuri:PropTypes.array,
  etape:PropTypes.array,
  dictionary:PropTypes.object,
  OpenTask:PropTypes.bool,
  getData:PropTypes.func,
  ref:PropTypes.func


}